import type { Placement } from '../config/get-config-popper';
import type { Position } from '@modules/product-tagging/type';

const useModalPlacement = (
    tagPosition: Position,
    modalWidth: number,
    boxWidth: number,
): Placement => {
    const tagOffsetX = (tagPosition.x * boxWidth) / 100;
    return tagOffsetX > modalWidth ? 'left-start' : 'right-start';
};

export default useModalPlacement;
